var styles = {"navbar":"navkit__Navbar__navbar","navbarContent":"navkit__Navbar__navbarContent","customActions":"navkit__Navbar__customActions","isFullWidth":"navkit__Navbar__isFullWidth","isHideNavigation":"navkit__Navbar__isHideNavigation"};

export { styles as default };
